export enum ClassifierAttributeDefinitionCode {
  GRADUATION_DOCUMENT_TYPE_DISCLOSURE_ALLOWED = 'GRADUATION_DOCUMENT_TYPE_DISCLOSURE_ALLOWED',
}
